import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { cookieGet } from "../utils/cookie";
import { COOKIE_KEY } from "../configs/app";

const ProtectedRoute = ({ redirectPath = "/auth/login", children }) => {
  let history = useNavigate();
  const checkAuth = async () => {
    const val = await cookieGet(COOKIE_KEY);
    if (!val) {
      return history(redirectPath);
    }
  };
  useEffect(() => {
    checkAuth();
  }, []);

  return children;
};

export default ProtectedRoute;
